/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarScheduledIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarScheduledIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarScheduledIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarScheduledIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 10"
 style={{'--as-1-2qj2Gv': alignSelf,'--mt-2-2qj2Gv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2qj2Gv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2qj2Gv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2qj2Gv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2qj2Gv': opacity,'--w-10-2qj2Gv': typeof width === 'number' ? `${width}px` : width,'--h-11-2qj2Gv': typeof height === 'number' ? `${height}px` : height,'--f-12-2qj2Gv': fill,'--a-7-2qj2Gv': isAnimated ? animation : "none",'--sd-8-2qj2Gv': isAnimated ? strokeDashoffset : 0,'--sd-9-2qj2Gv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarScheduledIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.214.714a.714.714 0 00-1.428 0v.715H1.07C.48 1.429 0 1.909 0 2.5v6.429C0 9.52.48 10 1.071 10H8.93C9.52 10 10 9.52 10 8.929V2.5c0-.592-.48-1.071-1.071-1.071h-.715V.714a.714.714 0 10-1.428 0v.715H3.214V.714zM7.19 4.638a.536.536 0 00-.806-.705L4.26 6.359l-.667-.667a.536.536 0 10-.758.758l1.072 1.072a.536.536 0 00.782-.026l2.5-2.858z"
 style={{'--f-12-2qj2Gv': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}